import { InfoChip } from '@components/index';
import { OnTheRoadIcon } from '@img/icons';
import DoNotDisturbAltOutlinedIcon from '@mui/icons-material/DoNotDisturbAltOutlined';
import PendingOutlined from '@mui/icons-material/PendingOutlined';
import Schedule from '@mui/icons-material/Schedule';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import PaidOutlined from '@mui/icons-material/PaidOutlined';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import ArticleOutlined from '@mui/icons-material/ArticleOutlined';
import ReceiptOutlined from '@mui/icons-material/ReceiptOutlined';
import AssignmentLateOutlined from '@mui/icons-material/AssignmentLateOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import DoNotDisturbOutlined from '@mui/icons-material/DoNotDisturbOutlined';
import UploadFileOutlined from '@mui/icons-material/UploadFileOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { CHIP_SIZE, TChipStatus } from '@types';

type TProps = {
	status: TChipStatus;
	logoOnly?: boolean;
	page?: string;
	size?: CHIP_SIZE;
}
type MI = {
	[key:string]: React.ComponentType;
}

const MaterialIcons:MI = {
	'PendingOutlined': PendingOutlined,
	'UploadFileOutlined': UploadFileOutlined,
	'Schedule': Schedule,
	'PeopleAltOutlined': PeopleAltOutlined,
	'LocationOnOutlined': LocationOnOutlined,
	'PaidOutlined': PaidOutlined,
	'CancelOutlined': CancelOutlined,
	'ArticleOutlined': ArticleOutlined,
	'ReceiptOutlined': ReceiptOutlined,
	'AssignmentLateOutlined': AssignmentLateOutlined,
	'DescriptionOutlined': DescriptionOutlined,
	'CheckOutlined': CheckOutlined,
	'DoNotDisturbOutlined': DoNotDisturbOutlined,
	'CheckCircleOutlineOutlined': CheckCircleOutlineOutlinedIcon
};

export const ShipmentStatusChip = (props:TProps) => {
	const {
		status,
		logoOnly = false,
		page = '',
		size = CHIP_SIZE.LARGE,
	} = props;
	const mdIcon = status?.icon ? MaterialIcons[status?.icon] : undefined;
	const showIcon = status?.icon ? true : false; // eslint-disable-line
	let icon = mdIcon;
	if (page === 'transport' && status?.short === 'POD Rejected') {
		icon = DoNotDisturbAltOutlinedIcon;
	} else if (status?.icon === 'Schedule') {
		icon = OnTheRoadIcon;
	}
	return <InfoChip text={status?.short} size={size} iconOnly={logoOnly} showIcon={showIcon} type={status?.type} CustomIcon={icon ?? undefined} />;
}
